var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5.5A8.5 8.5 0 0 1 50 9v33a8.5 8.5 0 0 1-8.5 8.5h-33A8.5 8.5 0 0 1 0 42V9A8.5 8.5 0 0 1 8.5.5h33Z",
    fill: "#1677F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5.5A8.5 8.5 0 0 1 50 9v33a8.5 8.5 0 0 1-8.5 8.5h-33A8.5 8.5 0 0 1 0 42V9A8.5 8.5 0 0 1 8.5.5h33Z",
    stroke: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.446 28.754.771-5.041h-4.834v-3.27c0-1.378.675-2.72 2.84-2.72h2.195V13.43s-1.995-.343-3.903-.343c-3.981 0-6.583 2.416-6.583 6.785v3.84h-4.424v5.04h4.424v12.182a17.895 17.895 0 0 0 5.451 0V28.754h4.063Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h50v50H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.08025c792d1dfd7a11205c8c486a64a1.svg";
export { ForwardRef as ReactComponent };